import { createPropsRestProxy as _createPropsRestProxy, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { nanoid } from 'nanoid';
import { computed, onMounted, ref, toRefs, watch } from 'vue';
import BaseDropdown from '../../legacy/ui/base-dropdown/base-dropdown.vue';
import { BaseList, BaseSelectItem } from '../../ui/base-list';
import DropdownMenuLayout from '../../legacy/ui/dropdown-menu-layout/dropdown-menu-layout.vue';
import { useListSelect } from '../../lib/list-selection';
import { useI18N } from '../../legacy/lib/use-i18n';
import BaseInput from '../../legacy/ui/base-input/base-input.vue';
import { useTimePicker } from './useTimePicker';


export default /*@__PURE__*/_defineComponent({
  __name: 'base-timepicker',
  props: {
    value: {},
    min: {},
    name: {},
    id: { default: () => (nanoid()) },
    placeholder: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = _createPropsRestProxy(__props, ["id"]);
const emit = __emit;

const { value, min } = toRefs(props);

const i18n = useI18N();

// View variables
const focused = ref(false);
const displayedValue = ref('');
const inserting = ref(false);

const dropdownSize = computed(() => {
  return min.value ? 'smaller' : 'date';
});

// Time picker logic
const { parseInput, selected, items } = useTimePicker({
  modelValue: value,
  minTime: min
});

const selectedIndex = computed(() => {
  return items.value.findIndex((item) => item.id === selected.value);
});

// Select behavior

const { selectableItems, onHover, toggle, hoveredIndex } = useListSelect({
  items,
  required: true,
  modelValue: selected.value,
  onChange: (value) => {
    inserting.value = false;
    focused.value = false;
    emit('change', value!);
  },
  useKeyboardEvents: focused
});

onMounted(() => {
  onHover(selectedIndex.value);
});

// Handlers

const handleOpen = () => {
  focused.value = true;
  if (hoveredIndex.value === null) {
    onHover(2);
  }
};

const handleKey = () => {
  if (!focused.value) {
    handleOpen();
  }

  setTimeout(() => {
    if (hoveredIndex.value !== null) {
      emit('change', items.value[hoveredIndex.value].name);
    }
  }, 0);
};

const handleReset = () => {
  inserting.value = false;
  displayedValue.value = selected?.value || '';
};

const handleBeforeInput = (event) => {
  if (!event.data) {
    return;
  }
  if (!/[\d:]/g.test(event.data)) {
    event.preventDefault();
  }
};
const handleInput = (input: string) => {
  inserting.value = true;
  try {
    const time = parseInput(input);
    const idx = items.value.findIndex((e) => e.name === time);
    onHover(idx);

    emit(
      'change',
      time
    );
  } catch {}
};

const handleBlur = () => {
  // focused.value = false;
  handleReset();
};

const handleEnter = (event: KeyboardEvent) => {
  if (!focused.value) {
    return;
  }
  event.preventDefault();
  focused.value = false;
};

watch(selected, () => {
  if (!inserting.value) {
    handleReset();
  }
}, {
  immediate: true
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDropdown, {
    disabled: !_unref(items).length,
    shown: focused.value,
    onHidden: _cache[1] || (_cache[1] = ($event: any) => {handleReset(); focused.value = false}),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (focused.value = true)),
    onBlur: handleBlur
  }, {
    default: _withCtx(({ show }) => [
      _createVNode(BaseInput, _mergeProps(_ctx.$attrs, {
        id: __props.id,
        value: displayedValue.value,
        maxlength: "5",
        name: __props.name,
        placeholder: __props.placeholder,
        disabled: __props.disabled,
        required: __props.required,
        readonly: __props.readonly,
        invalid: __props.invalid,
        class: _ctx.$style.timeInput,
        autocomplete: "off",
        onInput: _cache[0] || (_cache[0] = ($event: any) => {
          displayedValue.value = $event;
          handleOpen();
          handleInput($event);
        }),
        onClick: handleOpen,
        onBeforeinput: handleBeforeInput,
        onKeydown: [
          _withKeys(_withModifiers(($event: any) => {show(); handleKey()}, ["exact","prevent"]), ["down"]),
          _withKeys(_withModifiers(($event: any) => {show(); handleKey()}, ["exact","prevent"]), ["up"]),
          _withKeys(_withModifiers(handleEnter, ["exact"]), ["enter"])
        ]
      }), null, 16, ["id", "value", "name", "placeholder", "disabled", "required", "readonly", "invalid", "class", "onKeydown"])
    ]),
    content: _withCtx(() => [
      _createVNode(DropdownMenuLayout, { size: dropdownSize.value }, {
        content: _withCtx(() => [
          _createVNode(_unref(BaseList), {
            ref: "list",
            gap: 0,
            "active-index": selectedIndex.value,
            items: _unref(selectableItems),
            class: _normalizeClass(_ctx.$style.list)
          }, {
            item: _withCtx(({ item, index }) => [
              _createVNode(_unref(BaseSelectItem), {
                class: _normalizeClass(_ctx.$style.item),
                "show-checkbox": false,
                title: item.name,
                hovered: item.userSelection.hovered,
                selected: item.userSelection.selected,
                onClick: ($event: any) => (_unref(toggle)(item)),
                onMouseenter: ($event: any) => (_unref(onHover)(index))
              }, {
                "title-hint": _withCtx(() => [
                  (item.hint)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.hint)
                      }, " (" + _toDisplayString(_unref(i18n)(item.hint.name, { time: item.hint.time })) + ") ", 3))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "title", "hovered", "selected", "onClick", "onMouseenter"])
            ]),
            _: 1
          }, 8, ["active-index", "items", "class"])
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    _: 1
  }, 8, ["disabled", "shown"]))
}
}

})